module.exports = __webpack_public_path__ + "img/quality.708a1b80.jpg";